import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { comparator } from '@fi-shared/utils/array-sort-comparators';
import { BillingContactModel } from '@fi-app/billing/billing-contact.model';
import { fiInvoiceMethodType } from '../../customer-billing-invoice/invoice-method-type';
import { CustomerBillingOtherCustomerModel } from '../../customer-billing-other-customer/customer-billing-other-customer.model';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { EditTabModel, EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';

@Component({
    selector: 'fi-customer-billing-reseller-view',
    templateUrl: './customer-billing-reseller-view.component.html',
    styleUrls: ['./customer-billing-reseller-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-billing-reseller-view' },
    standalone: false,
})
export class CustomerBillingResellerViewComponent implements OnInit {
    @Input() customer: CustomerBillingOtherCustomerModel;

    ContactPerson: BillingContactModel;
    fiInvoiceMethodType = fiInvoiceMethodType;
    BillingReference: BillingContactModel;
    EditTabs: EditTabsModel;

    constructor(private fiStateService: FiStateService) {}

    ngOnInit() {
        this.ContactPerson =
            this.customer.Contacts.sort(comparator((item) => item.IsDefault, true))[0] || new BillingContactModel();
        this.BillingReference = this.customer.InvoiceInfo.BillingReference[0] || new BillingContactModel();
        this.setPageHeaderData();
    }

    private setPageHeaderData() {
        this.EditTabs = new EditTabsModel(this.customer.Name);
        this.EditTabs.Tabs.push(new EditTabModel('', ''));
    }

    editReseller() {
        this.fiStateService.go(FiStateNames.CustomerBilling.Resellers.Edit, { Id: this.customer.Id });
    }
}
